module.exports = __webpack_public_path__ + "static/media/manz.d7d44b93.png";